/**
 * Utility for managing bot editor session storage
 * Stores unsaved changes and original data for bot configurations
 */
const BotSessionData = {
    getSessionKey: (botId) => `bot_${botId}_session_data`,
    getOriginalKey: (botId) => `bot_${botId}_original_data`,

    save: (botId, data, originalData) => {
        if (!data) return;
        sessionStorage.setItem(BotSessionData.getSessionKey(botId), JSON.stringify(data));

        if (originalData) {
            sessionStorage.setItem(BotSessionData.getOriginalKey(botId), JSON.stringify(originalData));
        }
    },

    load: (botId) => {
        try {
            const data = sessionStorage.getItem(BotSessionData.getSessionKey(botId));
            return data ? JSON.parse(data) : null;
        } catch (e) {
            console.error("Failed to load from session storage:", e);
            BotSessionData.clear(botId);
            return null;
        }
    },

    loadOriginal: (botId) => {
        try {
            const data = sessionStorage.getItem(BotSessionData.getOriginalKey(botId));
            return data ? JSON.parse(data) : null;
        } catch (e) {
            console.error("Failed to load original data from session storage:", e);
            return null;
        }
    },

    clear: (botId) => {
        sessionStorage.removeItem(BotSessionData.getSessionKey(botId));
        sessionStorage.removeItem(BotSessionData.getOriginalKey(botId));
        // Clear new bot data as well
        sessionStorage.removeItem(BotSessionData.getSessionKey('new'));
        sessionStorage.removeItem(BotSessionData.getOriginalKey('new'));
    }
};

export default BotSessionData;
